// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-panel[data-v-0a7ff370] {\n  color: #fff;\n  height: 9.5vh;\n}\n.custom-panel-with-no-chart[data-v-0a7ff370] {\n  color: #fff;\n  height: 14vh;\n}\n.custom-panel-border[data-v-0a7ff370]:not(:last-child) {\n  border-bottom: 1px solid black;\n}\n.tile-border[data-v-0a7ff370] {\n  border-radius: 20px !important;\n}\n.custom-panel-heading[data-v-0a7ff370] {\n  border-radius: 20px 20px 0 0 !important;\n  background-color: #495057 !important;\n}\n", ""]);
// Exports
module.exports = exports;
